<template>
    <div class="mb-5">
        <p class="fw-bold fs-2 mb-3">{{ $t('FinancialInfoHome.sectionTitle') }}</p>
        <div class="d-flex align-items-start">
            <div class="nav flex-column nav-pills custom-width me-3" id="v-pills-tab" role="tablist"
                aria-orientation="vertical">
                <button class="nav-link active" id="v-pills-home-tab" data-bs-toggle="pill" data-bs-target="#v-pills-home"
                    type="button" role="tab" aria-controls="v-pills-home" aria-selected="true" style="">
                    <!-- Active state content -->
                    <div class="active-state">
                        <div class="row">
                            <div class="col-md-4 d-flex justify-content-center align-items-center ">
                                <div class="text-start title-fin">{{ $t('FinancialInfoHome.incomeTitle') }} <br> Q4 / 2567</div>
                            </div>
                            <div class="col-md-5 d-flex justify-content-center align-items-center text-start">
                                <div class="text-fin"><b>2,347 {{ $t('FinancialInfoHome.MillionBaht') }}</b></div>
                            </div>
                            <div class="col-md-3 d-flex justify-content-end align-items-center text-end">
                                <i class="fa-solid fa-minus"></i>
                            </div>
                        </div>
                    </div>
                    <!-- Inactive state content (will be hidden when active) -->
                    <div class="inactive-state">
                        <div class="row">
                            <div class="col-md-4 text-start">
                                <img src="../../assets/financial-icon/icon-income.png" class="mb-1">
                            </div>
                            <div class="col-md-5 justify-content-end align-items-center text-end">
                                <div class="text-start title-fin">{{ $t('FinancialInfoHome.incomeTitle') }} <br> Q4 / 2567</div>
                            </div>

                            <div class="col-md-3 d-flex justify-content-end align-items-center text-end">
                                <i class="fa-solid fa-plus"></i>
                            </div>
                        </div>
                    </div>
                </button>
                <button class="nav-link" id="v-pills-profile-tab" data-bs-toggle="pill" data-bs-target="#v-pills-profile"
                    type="button" role="tab" aria-controls="v-pills-profile" aria-selected="false" style="">
                    <!-- Active state content -->
                    <div class="active-state">
                        <div class="row">
                            <div class="col-md-4 d-flex justify-content-center align-items-center">
                                <div class="text-start title-fin">{{ $t('FinancialInfoHome.profitTitle') }}<br> Q4 / 2567</div>
                            </div>
                            <div class="col-5  justify-content-center align-items-center text-start">
                                <div class="text-fin"><b>-266 {{ $t('FinancialInfoHome.MillionBaht') }}</b></div>
                            </div>
                            <div class="col-md-3 d-flex justify-content-end align-items-center text-end">
                                <i class="fa-solid fa-minus"></i>
                            </div>
                        </div>
                    </div>
                    <!-- Inactive state content (will be hidden when active) -->
                    <div class="inactive-state">
                        <div class="row">
                            <div class="col-md-4 text-start">
                                <img src="../../assets/financial-icon/icon-profit.png" class="mb-1">
                            </div>
                            <div class="col-md-5 justify-content-end align-items-center text-end">
                                <div class="text-start">{{ $t('FinancialInfoHome.profitTitle') }} <br> Q4 / 2567</div>
                            </div>

                            <div class="col-md-3 d-flex justify-content-end align-items-center text-end">
                                <i class="fa-solid fa-plus"></i>
                            </div>
                        </div>
                    </div>
                </button>
                <button class="nav-link" id="v-pills-messages-tab" data-bs-toggle="pill" data-bs-target="#v-pills-messages"
                    type="button" role="tab" aria-controls="v-pills-messages" aria-selected="false" style="">
                    <!-- Active state content -->
                    <div class="active-state">
                        <div class="row">
                            <div class="col-md-4 d-flex justify-content-center align-items-center">
                                <div class="text-start title-fin">Presale <br> Q4 / 2567</div>
                            </div>
                            <div class="col-5  justify-content-center align-items-center text-start">
                                <div class="text-fin"><b>8,593 {{ $t('FinancialInfoHome.MillionBaht') }}</b></div>
                            </div>
                            <div class="col-md-3 d-flex justify-content-end align-items-center text-end">
                                <i class="fa-solid fa-minus"></i>
                            </div>
                        </div>
                    </div>
                    <!-- Inactive state content (will be hidden when active) -->
                    <div class="inactive-state">
                        <div class="row">
                            <div class="col-md-4 text-start">
                                <img src="../../assets/financial-icon/icon-presale.png" class="mb-1">
                            </div>
                            <div class="col-md-5 justify-content-end align-items-center text-end">
                                <div class="text-start">Presale <br> Q4 / 2567</div>
                            </div>

                            <div class="col-md-3 d-flex justify-content-end align-items-center text-end">
                                <i class="fa-solid fa-plus"></i>
                            </div>
                        </div>
                    </div>
                </button>
                <!-- <button class="nav-link" id="v-pills-settings-tab" data-bs-toggle="pill" data-bs-target="#v-pills-settings"
                    type="button" role="tab" aria-controls="v-pills-settings" aria-selected="false" style="">
                    <div class="active-state">
                        <div class="row">
                            <div class="col-md-4">
                                <div class="text-start">Bcaklog</div>
                                <div class="text-start">Q2 / 2567</div>
                            </div>
                            <div class="col-md-5 d-flex justify-content-center align-items-center text-start">
                                <h5><b>47,135 ล้านบาท</b></h5>
                            </div>
                            <div class="col-md-3 d-flex justify-content-end align-items-center text-end">
                                <i class="fa-solid fa-minus"></i>
                            </div>
                        </div>
                    </div>

                    <div class="inactive-state">
                        <div class="row">
                            <div class="col-md-2 text-start">
                                <img src="../../assets/financial-icon/icon-backlog.png" class="mb-1">
                            </div>
                            <div class="col-md-4">
                                <div class="text-start">Bcaklog</div>
                                <div class="text-start">Q2 / 2567</div>
                            </div>

                            <div class="col-md-6 d-flex justify-content-end align-items-center text-end">
                                <i class="fa-solid fa-plus"></i>
                            </div>
                        </div>
                    </div>
                </button> -->
            </div>

            <div class="tab-content" id="v-pills-tabContent">
                <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab"
                    tabindex="0">
                    <div class="tab-pane fade show active" id="v-pills-home" role="tabpanel"
                        aria-labelledby="v-pills-home-tab" tabindex="0">
                        <div class="container justify-content-center text-center mb-5" style="width: 810px;">
                            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                                <!-- Tab for Quarter -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link active" id="pills-income-quarter-tab" data-bs-toggle="pill"
                                        data-bs-target="#income-quarter" type="button" role="tab"
                                        aria-controls="income-quarter" aria-selected="true">
                                        {{ $t('FinancialInfoHome.quarterLabel') }}
                                    </button>
                                </li>
                                <!-- Tab for Yearly -->
                                <li class="nav-item" role="presentation">
                                    <button class="nav-link" id="pills-income-yearly-tab" data-bs-toggle="pill"
                                        data-bs-target="#income-yearly" type="button" role="tab"
                                        aria-controls="income-yearly" aria-selected="false">
                                         {{ $t('FinancialInfoHome.yearlyLabel') }}
                                    </button>
                                </li>
                            </ul>

                            <div class="tab-content" id="pills-tabContent" style="background-color: #F2F2F2;">
                                <!-- Tab content for Income Quarter -->
                                <div class="tab-pane fade show active" id="income-quarter" role="tabpanel"
                                    aria-labelledby="pills-income-quarter-tab" tabindex="0">
                                    <div ref="chartQuarteContainer" class="" style="height: 380px;"></div>

                                </div>
                                <!-- Tab content for Income Yearly -->
                                <div class="tab-pane fade" id="income-yearly" role="tabpanel"
                                    aria-labelledby="pills-income-yearly-tab" tabindex="0">
                                    <div ref="chartYearlyContainer" class="" style="height: 380px;"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="v-pills-profile" role="tabpanel" aria-labelledby="v-pills-profile-tab"
                    tabindex="0">
                    <div class="container justify-content-center text-center mb-5" style="width: 810px;">
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <!-- Tab for Quarter -->
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="pills-profit-quarter-tab" data-bs-toggle="pill"
                                    data-bs-target="#profit-quarter" type="button" role="tab" aria-controls="profit-quarter"
                                    aria-selected="true">
                                    {{ $t('FinancialInfoHome.quarterLabel') }}
                                </button>
                            </li>
                            <!-- Tab for Yearly -->
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="pills-profit-yearly-tab" data-bs-toggle="pill"
                                    data-bs-target="#profit-yearly" type="button" role="tab" aria-controls="profit-yearly"
                                    aria-selected="false">
                                    {{ $t('FinancialInfoHome.yearlyLabel') }}
                                </button>
                            </li>
                        </ul>

                        <div class="tab-content" id="pills-tabContent" style="background-color: #F2F2F2;">
                            <!-- Tab content for Profit Quarter -->
                            <div class="tab-pane fade show active" id="profit-quarter" role="tabpanel"
                                aria-labelledby="pills-profit-quarter-tab" tabindex="0">
                                <div ref="chartProfitQuarteContainer" class="" style="height: 380px;"></div>
                            </div>
                            <!-- Tab content for Profit Yearly -->
                            <div class="tab-pane fade" id="profit-yearly" role="tabpanel"
                                aria-labelledby="pills-profit-yearly-tab" tabindex="0">
                                <div ref="chartProfitYearlyContainer" class="" style="height: 380px;"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade" id="v-pills-messages" role="tabpanel" aria-labelledby="v-pills-messages-tab"
                    tabindex="0">
                    <div class="container justify-content-center text-center mb-5" style="width: 810px;">
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <!-- Tab for Quarter -->
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="pills-presale-quarter-tab" data-bs-toggle="pill"
                                    data-bs-target="#presale-quarter" type="button" role="tab"
                                    aria-controls="presale-quarter" aria-selected="true">
                                    {{ $t('FinancialInfoHome.quarterLabel') }}
                                </button>
                            </li>
                            <!-- Tab for Yearly -->
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="pills-presale-yearly-tab" data-bs-toggle="pill"
                                    data-bs-target="#presale-yearly" type="button" role="tab" aria-controls="presale-yearly"
                                    aria-selected="false">
                                    {{ $t('FinancialInfoHome.yearlyLabel') }}
                                </button>
                            </li>
                        </ul>

                        <div class="tab-content" id="pills-tabContent" style="background-color: #F2F2F2;">
                            <!-- Tab content for Presale Quarter -->
                            <div class="tab-pane fade show active" id="presale-quarter" role="tabpanel"
                                aria-labelledby="pills-presale-quarter-tab" tabindex="0">
                                <div ref="chartPresaleQuarterContainer" class="" style="height: 380px;"></div>
                            </div>
                            <!-- Tab content for Presale Yearly -->
                            <div class="tab-pane fade" id="presale-yearly" role="tabpanel"
                                aria-labelledby="pills-presale-yearly-tab" tabindex="0">
                                <div ref="chartPresaleYearlyContainer" class="" style="height: 380px;"></div>
                            </div>
                        </div>
                    </div>


                </div>
                <div class="tab-pane fade" id="v-pills-settings" role="tabpanel" aria-labelledby="v-pills-settings-tab"
                    tabindex="0">
                    <div class="container justify-content-center text-center mb-5" style="width: 810px;">
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <!-- Tab for Quarter -->
                            <li class="nav-item" role="presentation">
                                <button class="nav-link active" id="pills-backlog-quarter-tab" data-bs-toggle="pill"
                                    data-bs-target="#backlog-quarter" type="button" role="tab"
                                    aria-controls="backlog-quarter" aria-selected="true">
                                    {{ $t('FinancialInfoHome.quarterLabel') }}
                                </button>
                            </li>
                            <!-- Tab for Yearly -->
                            <li class="nav-item" role="presentation">
                                <button class="nav-link" id="pills-backlog-yearly-tab" data-bs-toggle="pill"
                                    data-bs-target="#backlog-yearly" type="button" role="tab" aria-controls="backlog-yearly"
                                    aria-selected="false">
                                    {{ $t('FinancialInfoHome.yearlyLabel') }}
                                </button>
                            </li>
                        </ul>

                        <div class="tab-content" id="pills-tabContent" style="background-color: #F2F2F2;">
                            <!-- Tab content for Backlog Quarter -->
                            <div class="tab-pane fade show active" id="backlog-quarter" role="tabpanel"
                                aria-labelledby="pills-backlog-quarter-tab" tabindex="0">
                                <div ref="chartBacklogQuarterContainer" class="" style="height: 380px;"></div>
                            </div>
                            <!-- Tab content for Backlog Yearly -->
                            <div class="tab-pane fade" id="backlog-yearly" role="tabpanel"
                                aria-labelledby="pills-backlog-yearly-tab" tabindex="0">
                                <div ref="chartBacklogYearlyContainer" class="" style="height: 380px;"></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Highcharts from 'highcharts';

export default {
    name: 'FinancialInforHome',
    props: {
        title: String,
        incomeTitle: String,
        incomeValue: String,
        profitTitle: String,
        profitValue: String,
        presaleTitle: String,
        presaleValue: String,
        backlogTitle: String,
        quarterLabel: String,
        yearlyLabel: String,
        quarterName: String,
        MillionBaht:String
    },
    components: {},
    data() {
        return {
            IncomeQuarterData: [
                { year_1: "2471", year_2: "3213", year_3: "3437", year_4: "2988", year_5: "2347" },
            ],

            IncomeYearlyData: [
                { year_1: "11114", year_2: "15943", year_3: "15741", year_4: "15157", year_5: "11985" },
            ],

            ProfitQuarterData: [
                { year_1: "47", year_2: "464", year_3: "452", year_4: "402", year_5: "-266" },
            ],

            ProfitYearlyData: [
                { year_1: "2662", year_2: "3194", year_3: "3775", year_4: "2718", year_5: "1052" },
            ],

            PresaleQuarterData: [
                { year_1: "10330", year_2: "8139", year_3: "10192", year_4: "8518", year_5: "8593" },
            ],

            PresaleYearlyData: [
                { year_1: "25774", year_2: "30257", year_3: "41032", year_4: "47267", year_5: "35442" },
            ],

        };
    },
    methods: {},
    async mounted() {
        this.IncomeQuarter = [
            parseFloat(this.IncomeQuarterData[0]?.year_1),
            parseFloat(this.IncomeQuarterData[0]?.year_2),
            parseFloat(this.IncomeQuarterData[0]?.year_3),
            parseFloat(this.IncomeQuarterData[0]?.year_4),
            parseFloat(this.IncomeQuarterData[0]?.year_5),
        ];

        this.IncomeYearly = [
            parseFloat(this.IncomeYearlyData[0]?.year_1),
            parseFloat(this.IncomeYearlyData[0]?.year_2),
            parseFloat(this.IncomeYearlyData[0]?.year_3),
            parseFloat(this.IncomeYearlyData[0]?.year_4),
            parseFloat(this.IncomeYearlyData[0]?.year_5),
        ];

        this.ProfitQuarter = [
            parseFloat(this.ProfitQuarterData[0]?.year_1),
            parseFloat(this.ProfitQuarterData[0]?.year_2),
            parseFloat(this.ProfitQuarterData[0]?.year_3),
            parseFloat(this.ProfitQuarterData[0]?.year_4),
            parseFloat(this.ProfitQuarterData[0]?.year_5),
        ];

        this.ProfitYearly = [
            parseFloat(this.ProfitYearlyData[0]?.year_1),
            parseFloat(this.ProfitYearlyData[0]?.year_2),
            parseFloat(this.ProfitYearlyData[0]?.year_3),
            parseFloat(this.ProfitYearlyData[0]?.year_4),
            parseFloat(this.ProfitYearlyData[0]?.year_5),
        ];

        this.PresaleQuarter = [
            parseFloat(this.PresaleQuarterData[0]?.year_1),
            parseFloat(this.PresaleQuarterData[0]?.year_2),
            parseFloat(this.PresaleQuarterData[0]?.year_3),
            parseFloat(this.PresaleQuarterData[0]?.year_4),
            parseFloat(this.PresaleQuarterData[0]?.year_5),
        ];

        this.PresaleYearly = [
            parseFloat(this.PresaleYearlyData[0]?.year_1),
            parseFloat(this.PresaleYearlyData[0]?.year_2),
            parseFloat(this.PresaleYearlyData[0]?.year_3),
            parseFloat(this.PresaleYearlyData[0]?.year_4),
            parseFloat(this.PresaleYearlyData[0]?.year_5),
        ];

        Highcharts.chart(this.$refs.chartQuarteContainer, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['Q4/66', 'Q1/67', 'Q2/67', 'Q3/67', ' Q4/67'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                enabled: false,
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
                {
                    name: '',
                    data: this.IncomeQuarter.map((value, index) => ({
                        y: value,
                        color: index === this.IncomeQuarter.length - 1 ? '#E87D2E' : '#414042', // Color last column
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });

        Highcharts.chart(this.$refs.chartYearlyContainer, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['2563', '2564', '2565', '2566', '2567'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                enabled: false,
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
                {
                    name: '',
                    data: this.IncomeYearly.map((value, index) => ({
                        y: value,
                        color: index === this.IncomeYearly.length - 1 ? '#E87D2E' : '#414042', // Color last column
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });

        Highcharts.chart(this.$refs.chartProfitQuarteContainer, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['Q4/66', 'Q1/67', 'Q2/67', 'Q3/67', ' Q4/67'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                enabled: false,
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
                {
                    name: '',
                    data: this.ProfitQuarter.map((value, index) => ({
                        y: value,
                        color: index === this.ProfitQuarter.length - 1 ? '#E87D2E' : '#414042', // Color last column
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });

        Highcharts.chart(this.$refs.chartProfitYearlyContainer, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['2563', '2564', '2565', '2566', '2567'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                enabled: false,
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
                {
                    name: '',
                    data: this.ProfitYearly.map((value, index) => ({
                        y: value,
                        color: index === this.ProfitYearly.length - 1 ? '#E87D2E' : '#414042', // Color last column
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });

        Highcharts.chart(this.$refs.chartPresaleQuarterContainer, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['Q4/66', 'Q1/67', 'Q2/67', 'Q3/67', ' Q4/67'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                enabled: false,
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
                {
                    name: '',
                    data: this.PresaleQuarter.map((value, index) => ({
                        y: value,
                        color: index === this.PresaleQuarter.length - 1 ? '#E87D2E' : '#414042', // Color last column
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });


        Highcharts.chart(this.$refs.chartPresaleYearlyContainer, {
            chart: {
                type: 'column',
                backgroundColor: '#F2F2F2',
            },
            title: {
                text: '',
                style: {
                    fontFamily: 'Prompt, sans-serif',
                    fontSize: '30px',
                },
            },
            xAxis: {
                categories: ['2563', '2564', '2565', '2566', '2567'],
                labels: {
                    style: {
                        fontFamily: 'Prompt, sans-serif',
                        fontSize: '14px',
                    },
                },
            },
            yAxis: [
                {
                    title: {
                        text: '',
                    },
                    labels: {
                        enabled: false,
                    },
                    lineWidth: 0,
                    gridLineWidth: 0,
                },
                {
                    title: {
                        text: '',
                    },
                    opposite: false,
                    labels: {
                        formatter: function () {
                            return Highcharts.numberFormat(this.value, 0, ',', ',');
                        },
                    },
                }
            ],
            tooltip: {
                enabled: false,
                formatter: function () {
                    return this.series.name + ': <b>' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</b>';
                },
            },
            series: [
                {
                    name: '',
                    data: this.PresaleYearly.map((value, index) => ({
                        y: value,
                        color: index === this.PresaleYearly.length - 1 ? '#E87D2E' : '#414042', // Color last column
                    })),
                    type: 'column',
                    dataLabels: {
                        enabled: true,
                        style: {
                            fontFamily: 'Prompt, sans-serif',
                            fontSize: '14px',
                        },
                        formatter: function () {
                            return Highcharts.numberFormat(this.y, 0, ',', ',');
                        },
                    },
                    colorByPoint: true,
                },
            ],
            credits: {
                enabled: false,
            },
        });




    }
};

</script>
<style scoped>
.parent {
    position: relative;
    padding: 5px;
    padding-left: 100px;
    min-height: 50px;
}

.parent .fixed {
    position: absolute;
    left: 5px;
}

.parent {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
}

.inactive-state {
    display: none;
}

.nav-link:not(.active) .active-state {
    display: none;
}

.nav-link:not(.active) .inactive-state {
    display: block;
}

.nav-link.active .active-state {
    display: block;

}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
    color: var(--bs-nav-pills-link-active-color);
    background-color: #414042;
    padding-right: 60px;
    padding-left: 60px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-radius: 0;
}

.title-fin {
    font-size: 14px;
}

.text-fin {
    font-size: 23px;
}
</style>